import {
  IsBoolean,
  IsIn,
  IsOptional,
  IsString,
  Matches,
  MaxLength,
  ValidateNested
} from 'class-validator';
import { Type } from 'class-transformer';
import { validationPatterns } from '../../constants';
import { CityCreateDto } from './city-create.dto';
import { CustomerBusinessType } from '../../enum/piecloud-signup';

export class CustomerLeadUpdateDto {
  @IsString()
  @IsOptional()
  @MaxLength(150)
  firstName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  lastName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  @Matches(validationPatterns.email)
  contactEmail?: string;

  @IsString()
  @IsOptional()
  @MaxLength(20)
  contactPhone?: string;

  @IsString()
  @IsOptional()
  @MaxLength(2)
  contactPhoneCountryCode?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  brandName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  businessName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  companyNumber?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => CityCreateDto)
  businessCity?: CityCreateDto;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  businessAddress?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  businessAddressLine2?: string;

  @IsString()
  @IsOptional()
  @MaxLength(20)
  businessAddressPostCode?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  @Matches(validationPatterns.url)
  businessURL?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  noLocations?: string;

  @IsString()
  @IsOptional()
  @IsIn(Object.values(CustomerBusinessType))
  businessType?: CustomerBusinessType;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  merchantGroupName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  merchantName?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  @Matches(validationPatterns.email)
  merchantEmail?: string;

  @IsString()
  @IsOptional()
  @MaxLength(20)
  merchantPhone?: string;

  @IsString()
  @IsOptional()
  @MaxLength(2)
  merchantPhoneCountryCode?: string;

  @IsString()
  @IsOptional()
  @MaxLength(150)
  merchantAddress?: string;

  @IsBoolean()
  @IsOptional()
  isSameAddress?: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => CityCreateDto)
  merchantCity?: CityCreateDto;
}